import * as React from "react";
import PropTypes from 'prop-types';

const SvgSocialmediaTwitter = props => {
  if (props.id !== "_svgsocialmediatwitter") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M20 4C11.163 4 4 11.164 4 20c0 8.837 7.163 16 16 16 8.836 0 16-7.163 16-16 0-8.836-7.164-16-16-16m8.29 12.293c.007.174.011.347.011.523 0 5.337-4.062 11.492-11.493 11.492-2.28 0-4.403-.67-6.19-1.815.314.038.635.056.963.056a8.09 8.09 0 005.016-1.73 4.041 4.041 0 01-3.773-2.803 4.067 4.067 0 001.824-.07 4.043 4.043 0 01-3.24-3.96v-.051a4.013 4.013 0 001.83.505 4.036 4.036 0 01-1.798-3.361c0-.74.199-1.435.547-2.031a11.466 11.466 0 008.325 4.22 4.04 4.04 0 016.884-3.684 8.086 8.086 0 002.564-.98 4.047 4.047 0 01-1.775 2.235 8.058 8.058 0 002.32-.636 8.234 8.234 0 01-2.016 2.09" fill="#202020" /></svg>;
};

SvgSocialmediaTwitter.displayName = "_svgsocialmediatwitter";
SvgSocialmediaTwitter.propTypes = {
  id: PropTypes.string
};
SvgSocialmediaTwitter.defaultProps = {
  id: ''
};
export default SvgSocialmediaTwitter;